
export class FbResponse {
  id: string;
  name: string;
  email: string;
  firstName: string;
  lastName: string;
  authToken: string;
  provider: string;
  }
